import AttendAllowanceIndexPage from './AttendAllowanceIndexPage';

export default AttendAllowanceIndexPage;
